import {Injectable} from '@angular/core';
import {FormControl, Validators, FormBuilder, FormGroup, AbstractControl} from "@angular/forms";

@Injectable()
export class PedidoModel {

  public savePedidoCacheInterval: any;

  public field: any = {

    numped:   <string> '',
    sitped:   <string> '',
    codcli:   <string> '79258',
    nomcli:   <string> 'ESTHER E KAIQUE PIZZARIA DELIVERY LTDA',
    vlrseg:   <string> '',

    datemi:   <string> '',
    codtns:   <string> '90100',

    codcpg:   <string> '3',
    descpg:   <string> '20/40 DIAS',

    codpor:   <string> '',
    despor:   <string> '',

    codfpg:   <string> '',
    desfpg:   <string> '',

    codven:   <string> '',
    nomven:   <string> '',

    codrep:   <string> '9999',
    nomrep:   <string> 'PROPRIA EMPRESA',

    codcrt:   <string> '99',
    descrt:   <string> '99-CARTEIRA SIMPLES',

    sigmoe:   <string> 'R$',
    codmoe:   <string> '01',

    usucon:   <string> '',
    obsped:   <string> '',
    usuobsped:   <string> '',

    newped:   <string> '',
    editped:   <string> '',

    hidechamado:   <string> '',

    valor:   <string> '',
    vlrliq:   <string> '',

    filial:   <string> '9-1',
    filialfat:   <string> '',

    produtos: <any> [],
    parcelas: <any> []

  };

  constructor(public formBuilder: FormBuilder) {
    this.resetFormPedido();
  }

  resetFormPedido() {
    for (let prop in this.field) {
      eval("this.field." + prop + " = '' ");
    };
  }

}



// WEBPACK FOOTER //
// ./src/model/pedido.model.ts